var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useLoader } from 'ziphy-web-shared/basic/hooks';
import { WithLoaderWrapper } from 'ziphy-web-shared/basic/lib/loaders';
import styles from '@nedoShared/modules/notes/Notes.module.scss';
import SectionAddendum from '@nedoShared/modules/notes/section/sectionAddendum/SectionAddendum';
import { $legacyNotes as $notes } from './LegacyNotes.store';
import SectionAddAddendum from './section/SectionAddAddendum';
import SectionEncounter from './section/SectionEncounter';
import SectionSign from './section/SectionSign';
import Sidebar from './ui/Sidebar';
import SidebarContent from './ui/SidebarContent';
const LegacyNotes = ({ appointment, encounter, patient, isStartProvider, isLoading: isApptLoading, }) => {
    const { t } = useTranslation();
    const { isLoading } = useLoader(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!encounter || isApptLoading)
            return;
        yield $notes.open({ appointment, encounter, patient, isStartProvider });
    }), [encounter === null || encounter === void 0 ? void 0 : encounter.id, isApptLoading]);
    useEffect(() => {
        if (isLoading)
            return;
        $notes.UPDATE_CONTEXT({ appointment, encounter, patient, isStartProvider });
    }, [encounter, appointment, patient]);
    useEffect(() => () => $notes.clear(true), []);
    return (_jsx(WithLoaderWrapper, Object.assign({ id: 'notes_wrapper', isLoading: isLoading, loader: isApptLoading ? _jsx(_Fragment, {}) : undefined, className: styles.wrapper }, { children: _jsx("div", Object.assign({ className: classNames(styles.container, 'container') }, { children: $notes.encounter ? (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: styles.inner }, { children: _jsxs("div", Object.assign({ className: styles.content }, { children: [_jsxs("div", Object.assign({ className: styles.sections }, { children: [_jsx(SectionEncounter, {}), $notes.addendum.length > 0 && _jsx(SectionAddendum, { data: $notes.addendum }), ($notes.isEditable || $notes.isSigned) && _jsx(SectionSign, {}), $notes.isLocked && _jsx(SectionAddAddendum, {})] })), _jsx(SidebarContent, { className: styles.sidebarContent })] })) })), _jsx(Sidebar, { className: styles.sidebar })] })) : (!isApptLoading && _jsx("div", Object.assign({ className: styles.noResults }, { children: t('text.appt_no_encounters') }))) })) })));
};
export default observer(LegacyNotes);
